import { formatPhoneNumberIntl } from "react-phone-number-input";

export const formatNumber = (phone) => {
  if (!phone) return "";

  let value = String(phone).trim().replace(/[^\d+]/g, "");

  // Add +61 if no country code is present
  if (!value.startsWith("+")) {
    if (value.startsWith("0")) {
      value = value.slice(1);
    }

    if (!value.startsWith("61")) {
      value = `61${value}`;
    }

    value = `+${value}`;
  }

  return formatPhoneNumberIntl(value) || value;
};